import { render, staticRenderFns } from "./MerchantTaxProfile.vue?vue&type=template&id=03b4bdd8"
import script from "./MerchantTaxProfile.vue?vue&type=script&lang=js"
export * from "./MerchantTaxProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports